module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-3-e0919ee42e41aadade048e3df1a2bc75.svg";